function indexOf(arr, refer) {
    for (var i = 0; i < arr.length; i++) {
        if (arr[i] === refer) {
            return i;
        }
    }
    return -1;
}

const bridge = (function() {
    var callbacks = [], callbackID = 0, registerHandlers = [];
    document.addEventListener('PacificDidReceiveNativeCallback', function(e) {
        if (e.detail) {
            var detail = e.detail;
            var id = isNaN(parseInt(detail.id)) ? -1 : parseInt(detail.id);
            if (id != -1) {
                var callbackAndPolicy = callbacks[id];
                if (!callbackAndPolicy || callbackAndPolicy.length < 1) {
                    return;
                }
                var callback = callbackAndPolicy[0];
                var allowMultipleCallback = callbackAndPolicy[1] || 0;
                callback(detail.parameters, detail.error);
                if (!allowMultipleCallback) {
                    delete callbacks[id];
                }
            }
        }
    }, false);
    document.addEventListener('PacificDidReceiveNativeBroadcast', function(e) {
        if (e.detail) {
            var detail = e.detail;
            var name = detail.name;
            if (name !== undefined && registerHandlers[name]) {
                var namedListeners = registerHandlers[name];
                if (namedListeners instanceof Array) {
                    var parameters = detail.parameters;
                    // 使用压缩的话， 这句话压缩不过
                    // (handler) => { handler(parameters) }
                    namedListeners.forEach(function(handler) {
                        handler(parameters);
                    });
                }
            }
        }
    }, false);
    return {
        'post': function(action, parameters, callback, print, allowMultipleCallback) {
            var message = { 'action': action, 'parameters': parameters, 'print': print || 0 };
            if (callback) {
                var id = ++callbackID;
                callbacks[id] = [callback, allowMultipleCallback || 0];
                message['callback'] = id;
            }
            // For iOS
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.pacific) {
                window.webkit.messageHandlers.pacific.postMessage(message);
            } else {
                // For Android
                if (window.pacific && window.pacific.didReceiveMessage) {
                    window.pacific.didReceiveMessage(JSON.stringify(message));
                } else {
                    // For Apps Havn't Implement (Message Bridge)
                    var openURLString = 'pacific://postMessage?_json=' + encodeURIComponent(JSON.stringify(message));
                    var bridgeFrame = document.createElement('iframe');
                    bridgeFrame.setAttribute('src', openURLString);
                    document.documentElement.appendChild(bridgeFrame);
                    bridgeFrame.parentNode.removeChild(bridgeFrame);
                    bridgeFrame = null;
                }
            }
        },
        'dispatch': function(action, parameters, print) {
            return new Promise((resolve, reject) => {
                window.bridge.post(action, parameters, (result, error) => {
                    if (error) {
                        reject(error);
                    } else {
                        resolve(result);
                    }
                    
                }, print);
            });
        },
        'on': function(name, callback) {
            var namedListeners = registerHandlers[name];
            if (!namedListeners) {
                registerHandlers[name] = namedListeners = [];
            }
            namedListeners.push(callback);
            return function() {
                namedListeners[indexOf(namedListeners, callback)] = null;
            };
        },
        'off': function(name) {
            delete registerHandlers[name];
        }
    };
})();
export { bridge };
